import { FC } from "react";
import styles from "./LimitModal.module.scss";

interface LimitModalProps {
  handleCloseModal: () => void;
  maxScreens: number;
}

const LimitModal: FC<LimitModalProps> = ({ handleCloseModal, maxScreens }) => {
  return (
    <>
      <div
        onClick={handleCloseModal}
        className={styles.limitModalOverlay}
      ></div>
      <div className={styles.limitModalContainer}>
        <div onClick={handleCloseModal} className={styles.limitModalClose}>
          <img src="/img/cancel.svg" alt="Close Icon" />
        </div>
        <div className={styles.limitModalHeader}>
          <img src="/img/LimitIcon.svg" alt="Warning Icon" />
        </div>
        <h1>Too Many Screens Selected</h1>
        <p>
          You've selected over {maxScreens} screens. Please reduce your
          selection to continue.
        </p>
        <div className={styles.limitModalButtonContainer}>
          <button onClick={handleCloseModal}>Okay</button>
        </div>
      </div>
    </>
  );
};

export default LimitModal;
